import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { Config, useRedirect } from "@itarget/shared";
import {
  clearSsoCallbackCache,
  consumeSsoCallback,
  mapSsoTokenToEntityUser,
  redirectToSsoAuthorize,
  ssoRedirectUri,
  stripHashFromUrl,
} from "../../utils/sso";
import { auth, fetch } from "../../redux";

const SsoCallbackContainer = () => {
  const dispatch = useDispatch();
  const { goTo } = useRedirect();
  const [message, setMessage] = useState("Validando acesso...");
  const started = useRef(false);

  useEffect(() => {
    if (started.current) {
      return;
    }
    started.current = true;

    const callback = consumeSsoCallback();
    if (!callback.ok) {
      setMessage("Não foi possível validar o acesso. Redirecionando...");
      redirectToSsoAuthorize("/new-panel");
      return;
    }

    axios
      .post(`${Config.baseURLV2}api/sso/token`, {
        code: callback.code,
        clientId: "entity",
        tenant: Config.client,
        redirectUri: ssoRedirectUri(),
        codeVerifier: callback.codeVerifier,
      })
      .then((response) => {
        const payload = response?.data?.data || response?.data || {};
        if (!payload.accessToken) {
          throw new Error("SSO token vazio");
        }
        const user = mapSsoTokenToEntityUser(payload);
        dispatch(auth.actions.setUser(user));
        dispatch(auth.actions.setIsAutenticated(true));
        dispatch(fetch.actions.setToken(payload.accessToken));
        clearSsoCallbackCache();
        stripHashFromUrl();
        const nextPath = (callback.returnPath || "/new-panel").replace(/^\//, "");
        goTo(nextPath || "new-panel");
      })
      .catch(() => {
        clearSsoCallbackCache();
        setMessage("Não foi possível validar o acesso. Redirecionando...");
        redirectToSsoAuthorize("/new-panel");
      });
  }, [dispatch, goTo]);

  return <div>{message}</div>;
};

export default SsoCallbackContainer;
